import { Injectable } from '@angular/core'; import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'; import { FilePicker } from '@capawesome/capacitor-file-picker';
import { ActionSheet, ActionSheetButtonStyle } from '@capacitor/action-sheet'; import { Filesystem } from '@capacitor/filesystem'; import { ConfirmationService } from 'primeng/api'; 
@Injectable({
  providedIn: 'root'
})
export class MobileUploadService {
  constructor(
    private androidPermissions: AndroidPermissions,
    private confirmationService: ConfirmationService
  ) { }


  async requestAndroidPermissions(): Promise<boolean> {
    const permissions = [
      this.androidPermissions.PERMISSION.READ_MEDIA_IMAGES,
      this.androidPermissions.PERMISSION.READ_MEDIA_VIDEO,
      this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
    ];

    try {
      for (const permission of permissions) {
        const result = await this.androidPermissions.checkPermission(permission);
        if (!result.hasPermission) {
          const req = await this.androidPermissions.requestPermission(permission);
          if (!req.hasPermission) {
            console.warn(`Permissão negada: ${permission}`);
            return false;
          }
        }
      }
      return true;
    } catch (error) {
      console.error('Erro ao verificar permissões:', error);
      return false;
    }
  }


  async selectImage(): Promise<File | null> {
    try {
      const photo = await Camera.getPhoto({
        quality: 80,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Photos // ou CameraSource.Prompt para dar opção entre câmera e galeria
      });

      const blob = await fetch(photo.dataUrl!).then(res => res.blob());
      return new File([blob], 'upload.jpg', { type: blob.type });
    } catch (error) {
      console.error('Erro ao abrir a galeria:', error);
      return null;
    }
  }

  // mobile-upload.service.ts
  async selectVideo(): Promise<File | null> {
    try {
      const result = await FilePicker.pickFiles({
        types: ['video/*'],
      });
  
      if (result.files.length > 0) {
        const picked = result.files[0];
  
        if (picked.blob) {
          return new File([picked.blob], picked.name, {
            type: picked.mimeType || picked.blob.type,
          });
        }
  
        if (picked.path) {
          const fileData = await Filesystem.readFile({ path: picked.path });
  
          // Aqui garantimos que `fileData.data` é uma string Base64
          const byteCharacters = atob(fileData.data as string);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
  
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: picked.mimeType || 'video/mp4' });
  
          return new File([blob], picked.name, { type: blob.type });
        }
      }
  
      return null;
    } catch (err) {
      console.error('Erro ao selecionar vídeo:', err);
      return null;
    }
  }
  
  

  async promptMediaSelection(): Promise<'image' | 'video' | null> {
    const result = await ActionSheet.showActions({
      title: 'Selecionar tipo de mídia',
      message: 'Escolha o tipo de arquivo que deseja enviar',
      options: [
        { title: 'Imagem', style: ActionSheetButtonStyle.Default },
        { title: 'Vídeo', style: ActionSheetButtonStyle.Default },
        { title: 'Cancelar', style: ActionSheetButtonStyle.Cancel }
      ]
    });
  
    if (result.index === 0) return 'image';
    if (result.index === 1) return 'video';
    return null;
  }


  
  


}
